"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveCartResponseMapper = void 0;
var RetrieveCartResponseMapper = /** @class */ (function () {
    function RetrieveCartResponseMapper(data) {
        this.localData = data;
    }
    RetrieveCartResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return RetrieveCartResponseMapper;
}());
exports.RetrieveCartResponseMapper = RetrieveCartResponseMapper;
//# sourceMappingURL=RetrieveCartResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/RetrieveCartResponseMapper.js
// module id = 2062
// module chunks = 8